import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { useSessionStore } from "../services/stores";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";

import { useQueryRetrieveFarms } from "../services/stores/queries";

import { Farm } from "../types/farm"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

/**
 * Farms dropdown component is added to the navigation bar.  It lets the user select the farm to work with.
 * 
 * @returns 
 */
export const Farms = () => {

        const { data: farms,
            error: errorFarms,
            isLoading: isLoadingFarms,
            isError: isErrorFarms } = useQueryRetrieveFarms();

        const [currentFarmID, setCurrentFarmID] = useState<string>('');
        const [currentFarmName, setCurrentFarmName] = useState<string>('');
        const [farmImageURL, setFarmImageURL] = useState<string>('');
        const [farmHectares, setFarmHectares] = useState<number>(6);

//        const setCurrentSessionFarm = useSessionStore((state) => state.setCurrentFarm);

         const {setCurrentFarm: setCurrentSessionFarm} = useSessionStore();

        // When the user changes the currently selected farm, Save the new farm ID and name in 
        // the session store so that the user does not have to set it on every session.
        //
        const onHandleFarmIDChange = (e: any) => {
            e.preventDefault();
            storeCurrentFarmInCache(String(e.target.id));
        }


        const storeCurrentFarmInCache = (farmID: string) => {
            // Don't store if farmID is null/undefined
            if ((!farmID) || (farmID == 'null')) {
                return;
            }

            // A valid farmID is a GUIID-like string. It is at least 32 characters long.
            if (farmID.length >= 32) {
                const farm = farms?.find(f => f.farmID === farmID);
                
                // Only store if we found a valid farm
                if (farm) {
                    localStorage.setItem("currentFarmID", farmID);
                    localStorage.setItem("currentFarmName", farm.farmName || '');
                    localStorage.setItem("currentFarmImageURL", farm.imageURL || '');
                    localStorage.setItem("currentFarmHectares", String(farm.hectares || 6));

                    setCurrentFarmID(farmID);
                    setCurrentFarmName(farm.farmName);
                    setFarmImageURL(farm.imageURL);
                    setFarmHectares(farm.hectares || 6);
                }
            }
        }

        // When the component mounts, set the current farm ID, name and image URL from the session store.
        //
        useEffect(() => {

            if(currentFarmID === '') {
                const farmID = localStorage.getItem("currentFarmID")+'';
                const farmName = localStorage.getItem("currentFarmName")+'';
                const farmImageURL = localStorage.getItem("currentFarmImageURL")+'';
                const hectares = isNaN(Number(localStorage.getItem("currentFarmHectares")+''))?  10 : Number(localStorage.getItem("currentFarmHectares"));

                if (((farmName === '') || (farmName == null)) && farms && (farms.length > 0)) 
                {
                    setCurrentFarmID(farms[0].farmID+'');
                    setCurrentFarmName(farms[0].farmName+'');
                    setFarmImageURL(farms[0].imageURL+'');
                    setFarmHectares(farms[0].hectares?? 6);
                }

                if ((farmID != null) && (farmID != 'null')) {
                    setCurrentFarmID(farmID);
                    setCurrentFarmName(farmName);
                    setFarmImageURL(farmImageURL);
                    setFarmHectares(hectares);
                }

            }

            const farm = farms?.find(f => f.farmID === currentFarmID);

            if (!farm && farms && (farms.length > 0)) {
                setCurrentFarmID(farms[0].farmID+'');
                setCurrentFarmName(farms[0].farmName+'');
                setFarmImageURL(farms[0].imageURL+'');
                setFarmHectares(farms[0].hectares?? 6);
                storeCurrentFarmInCache(farms[0].farmID);
            }

            setCurrentSessionFarm({
                farmID: currentFarmID, 
                farmName: currentFarmName, 
                imageURL: farmImageURL,
                hectares: farmHectares,
                
            })


        }, [farms, currentFarmID]);

        const queryClient = useQueryClient();

        useEffect(() => {
            queryClient.invalidateQueries();
        }, [currentFarmID]);

        // If error or loading, display an icon.
        //
        if (isErrorFarms || !farms || errorFarms || isLoadingFarms || !currentFarmID) {
            return (<FontAwesomeIcon icon={faLocationDot} />)
        }

        // Display the farms dropdown.
        //    
        return (
            <UncontrolledDropdown nav inNavbar expand="xs">
              <DropdownToggle nav caret>
              <img
                  src={farmImageURL}
                  alt={'Farm'}
                  className="avatar img-fluid rounded-circle me-2"
                />
              </DropdownToggle>
              
               {
                farms && <DropdownMenu end>
                    {farms.map((farm: Farm) => {
                        return (
                            <DropdownItem onClick={onHandleFarmIDChange} key={farm.farmID}>
                                <img
                                    id={farm.farmID}
                                    src={farm.imageURL}
                                    alt={farm.farmName}
                                    width="20"
                                    className="align-middle me-1"
                                />
                                <span id={farm.farmID} className="align-middle">{farm.farmName}</span>
                            </DropdownItem>
                        )
                    })}
                </DropdownMenu>
              }        
            </UncontrolledDropdown>
        )
    }
